import { formatDateLocal } from "../../helpers/timeline";
export const columnsDataDevelopment = [
  {
    Header: "No",
    accessor: "__index", // virtual accessor
  },
  {
    Header: "Nama Karyawan",
    accessor: "name",
  },
  
  {
    Header: "Email Karyawan",
    accessor: "email",
  },

    {
    Header: "Role Karyawan",
    accessor: "role",
  },
  
   
  {
    Header: "Status Karyawan",
    accessor: "status",
  },

  {
    Header: "Created At",
    accessor: "created_at",
    Cell: (value) => formatDateLocal(value),
  },
  {
    Header: "Updated At",
    accessor: "updated_at",
    Cell: (value) => formatDateLocal(value),
  },
];
